import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3 19q-.825 0-1.413-.588A1.92 1.92 0 0 1 1 17V3q0-.825.588-1.413A1.92 1.92 0 0 1 3 1h6q.425 0 .713.288T10 2a.97.97 0 0 1-.288.713A.96.96 0 0 1 9 3H3v14h6q.425 0 .713.288T10 18a.97.97 0 0 1-.288.713A.96.96 0 0 1 9 19zm12.175-8H8a.97.97 0 0 1-.713-.288A.96.96 0 0 1 7 10q0-.425.288-.713A.96.96 0 0 1 8 9h7.175L13.3 7.125a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.313.94.94 0 0 1 .725.288L18.3 9.3q.3.3.3.7t-.3.7l-3.575 3.575q-.3.3-.713.288a1.01 1.01 0 0 1-.712-.313.98.98 0 0 1-.263-.713.97.97 0 0 1 .288-.687z"
    }, null, -1)
  ]))]))
}
export default { render: render }